import React from 'react';

const IconAppleMusic = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-apple-music"
  >
    <title>Applemusic</title>
    <path d="M9 18a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
    <path d="M9 12V6l10-2v10" />
    <path d="M19 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
  </svg>
);

export default IconAppleMusic;
